import { EMPTY_PROPOSAL_COPY_FOR_RECAL_MODEL } from "presentation/model/ProposalCopyingForRecal/ProposalCopyingForRecalModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: ProposalCopyingForRecalProvider,
    useTracked: useProposalCopyingForRecalTracked
} = createContainer(() => useState(EMPTY_PROPOSAL_COPY_FOR_RECAL_MODEL), { concurrentMode: true });
export { ProposalCopyingForRecalProvider, useProposalCopyingForRecalTracked };

